<template>
    <div id="app">
        <LineChart :data="chartData" :options="chartOptions" class="line-chart-wrapper"></LineChart>
    </div>
</template>

<script>
import LineChart from "./LineChart.js";

export default {
    name: "MarketValue",
    props: ['getMarketValuestArr', 'getMarketCalculationDateArr', 'marketString', 'initialString', 'wineDetailsChart'],
    components: {
        LineChart
    },
    computed: {
        chartData() {
            return {
                labels: this.getMarketCalculationDateArr,
                datasets: [
                    {
                        fill: false,
                        borderColor: 'rgb(0, 79, 127)',
                        tension: 0.1,
                        data: this.getMarketValuestArr.map(item => item.marketValue)
                    }
                ]
            }
        }
    },
    data() {
        const vm = this;

        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            callback: function (value, index, values) {
                                if (parseInt(value) >= 1000) {
                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                } else {
                                    if (value % 1 === 0) return value
                                }
                            }
                        },
                        position: 'right'
                    }]
                },
                elements: {
                    point: {
                        radius: 0
                    }
                },
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                tooltips: {
                    enabled: false,
                    mode: 'index',
                    intersect: false,
                    position: 'nearest',
                    custom: function (tooltipModel) {
                        if (window) {
                            var tooltipEl = document.getElementById('chartjs-tooltip');

                            if (window && !tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'chartjs-tooltip';
                                tooltipEl.innerHTML = '<table></table>';
                                document.body.appendChild(tooltipEl);
                            }

                            if (tooltipModel.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }

                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }

                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }

                            if (tooltipModel.body) {
                                var titleLines = tooltipModel.title || [];
                                var bodyLines = tooltipModel.body.map(getBody);

                                var innerHtml = '<thead>';
                                innerHtml += '</thead><tbody>';

                                bodyLines.forEach(function (body, i) {
                                    var colors = tooltipModel.labelColors[i];
                                    var style = 'background: #000';
                                    style += '; border-color:' + colors.borderColor;
                                    style += '; border-width: 2px';
                                    var span = '<span style="' + style + '"></span>';
                                    innerHtml += '<tr><td style="width: 70px">' + vm.marketString + '</td><td>€' + span + vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].marketValueFormatted + '</td></tr>';
                                    if (!vm.wineDetailsChart) {
                                        innerHtml += '<tr><td style="width: 70px">' + vm.initialString + '</td><td>€' + span + vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].investmentAmount + '</td></tr>';

                                        if (vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].performanceAmount < 0) {
                                            innerHtml += '<tr><td style="width: 70px; color: red">€' + vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].performanceAmount + '</td><td style="color: red"><svg width="8" height="5" style="margin-right: 3px; vertical-align: middle" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0.75L0.25 4.5H7.75L4 0.75Z" fill="red"/></svg>' + span + (parseInt(vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].performanceRate * 100) / 100) + '%</td></tr>';
                                        } else {
                                            innerHtml += '<tr><td style="width: 70px; color: #018671">€' + vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].performanceAmount + '</td><td style="color: #018671"><svg width="8" height="5" style="margin-right: 3px; vertical-align: middle" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0.75L0.25 4.5H7.75L4 0.75Z" fill="#018671"/></svg>' + span + (parseInt(vm.getMarketValuestArr[tooltipModel.dataPoints[0].index].performanceRate * 100) / 100) + '%</td></tr>';
                                        }
                                    }
                                });
                                innerHtml += '</tbody>';

                                var tableRoot = tooltipEl.querySelector('table');
                                tableRoot.innerHTML = innerHtml;
                            }

                            var position = this._chart.canvas.getBoundingClientRect();

                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = ((position.left + window.pageXOffset + tooltipModel.caretX) - 160) + 'px';
                            tooltipEl.style.top = position.top + window.pageYOffset + ((tooltipModel.caretY / 2) - window.pageYOffset) + 'px';
                            tooltipEl.style.fontFamily = 'Montserrat, sans-serif';
                            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                            tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.backgroundColor = 'rgb(229, 229, 229)'
                            tooltipEl.style.borderRadius = '4px'
                        }
                    }
                }
            },
        }
    }
};
</script>

<style scoped>
.line-chart-wrapper {
    max-width: 100%;
    width: 100%;
    height: 182px;
}
</style>
<style>
.wine-details-page .line-chart-wrapper {
    height: 250px
}
</style>
